import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/privacy_banner.png";
function Privacy() {
  return (
    <div className="terms-privacy">
      <HeroSection image={Banner} pageTitle="Privacy policy" />
      <section>
        <div className="container-fluid">
          <p>
            If you have any questions or require further information about our
            privacy policy, please contact us at
            <span className="fw-semibold">sales@samsdigital.in</span>.
          </p>
          <p>
            At <span className="fw-semibold">SAMS Digital</span>, we value the
            privacy of our visitors and clients. This Privacy Policy outlines
            the types of personal information we collect and how we use, store,
            and protect it.
          </p>

          <h4 className=" pb-3 pt-5">Log Files</h4>
          <p>
            Like many other websites,
            <span className="fw-semibold">SAMS Digital</span> utilizes log
            files. The information collected may include:
          </p>
          <p>
            <ul>
              <li>Internet Protocol (IP) addresses</li>
              <li>Browser type and version</li>
              <li>Internet Service Provider (ISP)</li>
              <li>Date/time stamps</li>
              <li>Referring/exit pages</li>
              <li>Number of clicks to analyze trends and user interaction</li>
            </ul>
          </p>
          <p>
            This information is used solely for analyzing trends, administering
            the site, and gathering demographic data. IP addresses and related
            details are
            <span className="fw-semibold">
              not linked to personally identifiable information.
            </span>
          </p>

          <h4 className=" pb-3 pt-5">Cookies & Web Beacons</h4>
          <p>
            <span className="fw-semibold">SAMS Digital</span> does not use
            cookies directly. However, third-party service providers and
            advertisers may use cookies or tracking technologies on our site to
            improve user experience.
          </p>

          <h4 className=" pb-3 pt-5">Google and Third-Party Cookies</h4>
          <p>
            <ul>
              <li>
                Google, as a third-party vendor, may use cookies to serve ads on
                our website.
              </li>
              <li>
                Google’s DART cookie enables personalized advertising based on
                user interactions across various websites.
              </li>
            </ul>
          </p>
          <p>
            Users can opt-out of DART cookie tracking by visiting Google’s
            privacy policy page:
          </p>
          <p>
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark">
              Google Ad & Content Network Privacy Policy.
            </a>
          </p>

          <p>
            Our advertising partners and third-party services may also use
            cookies and web beacons for:
          </p>
          <p>
            <ul>
              <li>Tracking advertisement effectiveness</li>
              <li>Personalizing content and ads</li>
              <li>Website traffic analysis</li>
            </ul>
          </p>
          <p>
            SAMS Digital has
            <span className="fw-semibold">
              no control over these third-party cookies.
            </span>
            You may manage or disable cookies through your browser settings.
          </p>

          <h4 className=" pb-3 pt-5">
            Third-Party Advertising & External Links
          </h4>
          <p>
            Our website may display third-party advertisements or contain links
            to external websites. These third-party services operate under their
            own privacy policies. We encourage users to review their respective
            privacy policies for detailed information on data collection and
            tracking.
          </p>
          <p>
            SAMS Digital <span className="fw-semibold">is not responsible</span>
            for the privacy practices of these third parties.
          </p>

          <h4 className=" pb-3 pt-5">Data Security & User Rights</h4>
          <p>
            We take appropriate security measures to safeguard your personal
            information. You have the right to:
          </p>
          <p>
            <ul>
              <li>
                <span className="fw-semibold">Access, modify, or delete</span>
                your personal data
              </li>
              <li>
                <span className="fw-semibold">Opt-out</span> of marketing
                communications
              </li>
              <li>
                <span className="fw-semibold">Request information</span> on data
                collection and usage
              </li>
            </ul>
          </p>
          <p>
            To exercise these rights, please contact us at
            <span className="fw-semibold">sales@samsdigital.in</span>.
          </p>

          <h4 className=" pb-3 pt-5">Changes to This Policy</h4>
          <p>
            We may update this Privacy Policy from time to time. Please review
            this page periodically for any changes. Continued use of our website
            signifies acceptance of the updated policy.
          </p>

          <h4 className=" pb-3 pt-5">Contact Us</h4>
          <p>For any concerns or queries, reach out to us at:</p>
          <p>
            <span className="fw-semibold">Email:</span> sales@samsdigital.in
          </p>
          <p>
            <span className="fw-semibold">Phone:</span> +91 7093970147
          </p>
          <p>
            <span className="fw-semibold">Website:</span> www.samsdigital.in
          </p>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
